import { memo } from "react";
import PropTypes from "prop-types";
import { transportPartnershipShape } from "app/utils/propTypes";
import Paragraphs from "app/pages/.shared/Paragraphs";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg.jsx";
import Video from "app/pages/.shared/Video/Video";
import FrequencyFlyersMarketing from "@brand/FrequencyFlyersMarketing/FrequencyFlyersMarketing";
import "./TransportPartnership.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const TRANSPORT_MEDIA_SIZES = {
	small: { width: 300 },
	medium: { width: 300 },
	large: { width: 300 },
	xlarge: { width: 300 },
};

const EMIRATES_PASS_MEDIA_SIZES = {
	small: { width: 768 },
	medium: { width: 978 },
	large: { width: 560, height: 300 },
	xlarge: { width: 560, height: 300 },
};

const TransportPartnership = ({
	headline,
	intro,
	logo,
	paragraphs,
	photo,
	video,
	emiratesPass,
}) => {
	return (
		<div className="transport-partnership">
			{headline && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="transport-partnership__title"
					component="h2"
				>
					{headline}
				</Typography>
			)}

			{logo.url && (
				<div className="transport-partnership__logo">
					<ProgressiveImg
						sizes={TRANSPORT_MEDIA_SIZES}
						src={logo.url}
						alt={logo.alt}
						thumbnail={logo.thumbnail}
					/>
				</div>
			)}

			{video && video.url && (
				<div className="transport-partnership__video">
					<Video autoplay={0} url={video.url} />
				</div>
			)}

			<FrequencyFlyersMarketing showSubLabel />

			<div className="transport-partnership__intro">
				<Paragraphs paragraphs={intro} enableHTMLFormatting={true} />
			</div>

			{photo.url && (
				<div className="transport-partnership__logo">
					<ProgressiveImg
						sizes={TRANSPORT_MEDIA_SIZES}
						src={photo.url}
						alt={photo.alt}
						thumbnail={photo.thumbnail}
					/>
				</div>
			)}

			<div className="transport-partnership__paragraphs">
				<Paragraphs paragraphs={paragraphs} enableHTMLFormatting={true} />
			</div>

			{emiratesPass && (emiratesPass.title || emiratesPass.text || emiratesPass.image) && (
				<div className="transport-partnership__emirates-pass">
					{emiratesPass.title && (
						<Typography
							variant={TYPOGRAPHY_VARIANTS.LARGE}
							isBold
							component="h3"
							className="transport-partnership__emirates-pass-title"
						>
							<Paragraphs paragraphs={emiratesPass.title} enableHTMLFormatting />
						</Typography>
					)}

					{emiratesPass.image && (
						<div className="transport-partnership__emirates-pass-image">
							<ProgressiveImg
								alt="My Emirates Pass"
								sizes={EMIRATES_PASS_MEDIA_SIZES}
								src={emiratesPass.image}
								thumbnail={emiratesPass.thumbnail}
							/>
						</div>
					)}

					{emiratesPass.text && (
						<div className="transport-partnership__emirates-pass-text">
							<Paragraphs paragraphs={emiratesPass.text} enableHTMLFormatting />
						</div>
					)}
				</div>
			)}
		</div>
	);
};

TransportPartnership.propTypes = {
	...transportPartnershipShape,
	emiratesPass: PropTypes.shape({
		title: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
		text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
		image: PropTypes.string,
		thumbnail: PropTypes.string,
	}),
};

TransportPartnership.defaultProps = { paragraphs: [], photo: {}, logo: {}, video: {} };

export default memo(TransportPartnership);
